import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "border-bottom-grey-2 pb-3 mb-3"
}
const _hoisted_2 = { class: "grid grid-cols-2 gap-4" }
const _hoisted_3 = { class: "mb-2" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "text-base font-bold" }, "Nopol", -1)
const _hoisted_5 = { class: "pl-4 text-sm font-normal" }
const _hoisted_6 = { class: "mb-2" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "text-base font-bold" }, "Trayek Sekarang", -1)
const _hoisted_8 = { class: "pl-4 text-sm font-normal" }
const _hoisted_9 = { class: "mb-2" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "text-base font-bold" }, "Kelas", -1)
const _hoisted_11 = { class: "pl-4 text-sm font-normal" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "text-base font-bold" }, "Jam Keberangkatan PP", -1)
const _hoisted_14 = { class: "pl-4" }
const _hoisted_15 = { class: "mb-4" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "label-text required" }, "Keterangan", -1)
const _hoisted_17 = { class: "invalid-feedback" }
const _hoisted_18 = { class: "container-btn-action" }
const _hoisted_19 = /*#__PURE__*/_createTextVNode("Selanjutnya")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", null, [
    (!_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_3, [
                _hoisted_4,
                _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.dataVehicle.Nopol), 1)
              ]),
              _createElementVNode("div", _hoisted_6, [
                _hoisted_7,
                _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.dataVehicle.TrayekDetail?.Trayek.Name), 1)
              ]),
              _createElementVNode("div", _hoisted_9, [
                _hoisted_10,
                _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.dataVehicle.TrayekDetail?.Trayek.MsClass?.Name), 1)
              ])
            ]),
            _createElementVNode("div", null, [
              (_ctx.dataVehicle.TrayekDetail?.TrayekSubs.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    _hoisted_13,
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("ul", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataVehicle.TrayekDetail?.TrayekSubs, (data) => {
                          return (_openBlock(), _createElementBlock("li", {
                            style: {"list-style-type":"disc","list-style-position":"inside"},
                            key: data
                          }, _toDisplayString(`${data.DepartureTime.slice(0, 5)} (PP ${data.Order})`), 1))
                        }), 128))
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (!_ctx.isLoading)
      ? (_openBlock(), _createBlock(_component_Form, {
          key: 1,
          onSubmit: _ctx.nextPage,
          "validation-schema": _ctx.schema,
          "initial-values": _ctx.initialValue,
          class: "form-container"
        }, {
          default: _withCtx(({ errors }) => [
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_15, [
                _hoisted_16,
                _createVNode(_component_Field, {
                  name: "Description",
                  as: "textarea",
                  rows: "5",
                  cols: "30",
                  placeholder: "Masukan alasan mutasi",
                  class: ""
                }),
                _createElementVNode("div", _hoisted_17, _toDisplayString(errors.Description), 1)
              ]),
              _createElementVNode("div", _hoisted_18, [
                _createVNode(_component_Button, {
                  class: "btn-primary mr-1",
                  type: "submit"
                }, {
                  default: _withCtx(() => [
                    _hoisted_19
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _: 1
        }, 8, ["onSubmit", "validation-schema", "initial-values"]))
      : _createCommentVNode("", true)
  ]))
}